export const isError = (value: Error | string): value is Error => {
	return (value as Error).message !== undefined;
};
